"use client"
import useMutation from "@src/hooks/use-mutation"
import { Toastify, Icons } from ".."
import { useRouter } from "next/navigation"
import { useCurrentUser } from "@src/hooks/use-current-user"

const LikeIcon = ({ collectionId, slug }) => {
  const { mutation } = useMutation()
  const router = useRouter()
  const { update, user } = useCurrentUser()
  const isLiked = user?.collection_ids?.includes(collectionId)
  const { collection_ids = [] } = user || {}

  const toggleLike = status => async () => {
    if (slug) {
      if (status) {
        await mutation({
          url: `/auth/wishlist/collection/${slug}/addToWishlist`,
          method: "POST",
          onSuccess: res => {
            if (res) {
              Toastify.success(
                res?.message || "Đã thêm vào danh sách yêu thích"
              )
              update({
                ...user,
                collection_ids: [...collection_ids, collectionId],
                type: "LOCAL_UPDATE"
              })
              router.refresh()
            }
          }
        })
      } else {
        await mutation({
          url: `/auth/wishlist/collection/${slug}/removeFromWishlist`,
          method: "DELETE",
          onSuccess: res => {
            if (res) {
              Toastify.success(
                res?.message || "Đã xóa khỏi danh sách yêu thích"
              )
              update({
                ...user,
                collection_ids: collection_ids.filter(
                  item => item !== collectionId
                ),
                type: "LOCAL_UPDATE"
              })
              router.refresh()
            }
          }
        })
      }
    }
  }

  return (
    <Icons
      name="heart"
      type="button"
      sx={{
        padding: "5px !important",
        "&:hover": {
          borderRadius: "50%"
        },
        ...(isLiked && {
          "& svg ": {
            fill: "#FC5E5E",
            color: "#FC5E5E"
          }
        })
      }}
      onClick={toggleLike(!isLiked)}
    />
  )
}

export default LikeIcon
